import { SessionStorageKeys } from '@aglenergy/shared-library';
import { store } from 'app/shared/store/store';
import { StoreKeys } from 'app/shared/constants/store-keys.enum';
import { ConfigModel } from 'app/shared/models/config.model';
import { PostcodeRange } from 'app/shared/models/energy/region.model';
import { ResponseError } from 'app/shared/models/response-error.error';
import { getHeaders } from 'app/shared/utilities/helper-functions';
import { generalContentService } from 'app/shared/services/general-content/general-content.service';
import { commonLinksApiService } from 'app/shared/services/common-links/common-links-api.service';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let window: any;

export class ConfigService {
  private configData = null;
  private static instance: ConfigService;

  public static get Instance(): ConfigService {
    return this.instance || (this.instance = new this());
  }

  public getConfigData = (): ConfigModel => this.configData;

  public async loadConfig(host: string): Promise<ConfigModel> {
    this.configData = store.get('configData');

    if (this.configData) {
      return this.configData;
    }

    return await this.getConfig(host).then((config) => {
      store.set('configData', config);
      this.configData = config;
      const webId = store.get(StoreKeys.webId) ?? 'master';
      generalContentService.getGeneralContent().then((res) => store.set(StoreKeys.generalContent, res.content));
      commonLinksApiService.getNbnCommonLinksByWebId(webId).then((res) => store.set(StoreKeys.nbnCommonLinks, res));
      return config;
    });
  }

  public getPostcodeRange(): PostcodeRange[] {
    return this.getWinConfig('ausPostcodeRanges') as PostcodeRange[];
  }

  public getHttpHeaders(isConfigServiceRequest = true): HeadersInit {
    const httpHeaders: HeadersInit = getHeaders(isConfigServiceRequest);

    const accessToken = sessionStorage.getItem(SessionStorageKeys.AccessToken);
    if (accessToken) {
      httpHeaders['Authorization'] = `Bearer ${accessToken}`;
    }
    return httpHeaders;
  }

  public async getConfig(host: string): Promise<ConfigModel> {
    return await fetch(`${host}/assets/config.json`)
      .then((r) => {
        if (!r.ok) {
          throw new ResponseError(`Unable to get config`);
        }
        return r.json();
      })
      .catch((e) => {
        throw new ResponseError(e);
      });
  }

  public getSamlLoginURL = async (redirectUri?: string): Promise<string> => {
    if (!this.configData) {
      const auth0 = await this.getAuthConfigData();
      this.configData = { ...this.configData, auth0 };
    }
    const returnUrl = redirectUri === '' ? `https://${window.location.host}${this.configData.auth0.redirect_uri}` : redirectUri;
    return `https://${this.configData.auth0.domain}/samlp/${this.configData.auth0.saml_client_id}?RelayState=ReturnUrl=${returnUrl}`;
  };

  public getAuthConfigData(): any {
    return this.configData.auth0;
  }

  private getWinConfig(key: string): any {
    if (window.config) {
      return window.config[key];
    }
    return null;
  }
}

export const configService = ConfigService.Instance;
